import { Tone } from "../../models";

export const getTransposeByFromMode = (mode: string): number => {
    const lookup: { [key: string]: number } = {
        "1": 0,
        "2": 4,
        "3": -3,
        "4": window.location.href.includes("/se/") ? -5 : 0,
        "5": -3,
        "6": 0,
        "7": -5,
        "8": -3,
        T: 1,
    };

    return lookup[mode] ?? 0;
};

export const getTransposeByFromToneObject = (tone: Tone): number => {
    if (!tone) {
        return getTransposeByFromMode("1");
    }

    const clefOffset = parseInt(tone.clef.slice(1));
    const offset =
        tone.clef.slice(0, 1) === "c" ? 9 - clefOffset : 5 - clefOffset;

    const recitingNote = NOTES[tone.recitingNote + offset];

    let transposedBy = -10;

    while (transposeNote(recitingNote, transposedBy) !== "A3") {
        transposedBy++;
    }

    return transposedBy;
};

export const NOTES = [
    "A2",
    "B2",
    "C3",
    "D3",
    "E3",
    "F3",
    "G3",
    "A3",
    "B3",
    "C4",
    "D4",
    "E4",
    "F4",
    "G4",
];

export const SHARP_MAP: Record<string, string> = {
    C: "C",
    "C#": "Db",
    D: "D",
    "D#": "Eb",
    E: "E",
    F: "F",
    "F#": "Gb",
    G: "G",
    "G#": "Ab",
    A: "A",
    "A#": "Bb",
    B: "B",
};

const TRANSPOSITION_TABLE = [
    "C",
    "Db",
    "D",
    "Eb",
    "E",
    "F",
    "Gb",
    "G",
    "Ab",
    "A",
    "Bb",
    "B",
];

export const transposeNote = (noteString: string, amount: number) => {
    const octave = parseInt(noteString[noteString.length - 1]);
    const note = noteString.slice(0, noteString.length - 1);
    const index = TRANSPOSITION_TABLE.indexOf(note);
    const transposedNote =
        TRANSPOSITION_TABLE[
            (TRANSPOSITION_TABLE.length * 2 + index + amount) %
                TRANSPOSITION_TABLE.length
        ];
    const transposedOctave =
        octave + Math.floor((index + amount) / TRANSPOSITION_TABLE.length);

    return `${transposedNote}${transposedOctave}`;
};
